import { sidebarName_ch } from "./sidebarName";
import { about } from "./aboutInfo";

export default {
  sidebarName: sidebarName_ch,
  about: about,
  chatArea: '聊天区',
  send: '发送',
  delete: '删除',
  delete1: '删除子账号',
  deletenotes: '点击可删除《某某》子账号',
  chancenotes: '点击可修改《某某》子账号',
  audience: '观展',
  stopTalkTips: '点击后将向观展方发送消息，通知其10分钟内结束洽谈！',
  talkInviteTips: '点击后系统将寻找正在排队当前时段的预约人并自动向其发送洽谈邀请。',
  stopTalk: '终止洽谈',
  endTalk: '结束洽谈',
  beginTalk: '开始展播',
  endForum: '结束',
  beginForum: '开始',
  payError: "支付失败",
  permissionDenied: '无法获取麦克风、摄像头权限,请允许浏览器及网页访问摄像头/麦克风设备。点击"确认"后您将退出直播间',
  ask: '提问',
  agree: '同意',
  talkEnded: '您的面试已结束，感谢您的参与。',
  forumEnded: '论坛已经结束',
  HTC: "使用说明",
  endTalkByAnchor: '您的面试已结束，感谢您的参与。',
  addToBlacklist: '您被请出了洽谈室',
  cancelAsk: '取消提问',
  askReject: '您的请求发言被拒绝',
  askAgree: '您的提问被同意',
  endAsk: '结束提问',
  addBlacklist: '加入黑名单',
  whiteboard: '白板',
  uploadFile: '上传文件',
  uploadSuccess: '上传成功',
  uploadFail: '上传失败',
  uploadProgress: '上传进度:',
  uploadVideoMax: '上传视频不能大于50M',
  uploadFileMax: '上传文件不能大于10M',
  joinLiveFail: '加入直播间失败',
  joinLiveSuccess: '加入直播间成功',
  uploadPic: '正在上传图片',
  uploadFiles: '正在上传文件',
  uploadFilesFormat: '不支持的文件格式',
  trancodingFailure: '转码失败',
  uploading: '上传中，当前进度:',
  transcodingTask: '创建转码任务',
  waitTranscodingTask: '正在排队等待转码',
  transcoding: '转码中，当前进度:',
  transcodingFinish: '转码完成',
  microphoneClose: '关闭了麦克风',
  microphoneOpen: '打开了麦克风',
  cameraClose: '关闭了摄像头',
  cameraOpen: '打开了摄像头',
  file: '文件',
  fileManage: '演示文件',
  appendixManage: '文件传输',
  appendixManage1: '企业文件',
  video: '视频',
  inputPlease: '请输入聊天内容..',
  title: '标题中文',
  // exhibition: "展会",
  jobFair:"招聘会",
  userInfo: "账户管理",
  personalCenter:"个人中心",
  login: "登录",
  search: "搜索",
  details: "详情",
  packUp: "收起",
  remark: "备注",
  loadingLogin: "登陆中...",
  findPwd: "找回密码",
  // register: "注册",
  register: "注册",
  english: "English",
  explain: "系统使用说明",
  exhibitionState: "展会状态",
  notEnter: "暂不进入",
  state: "状态",
  promptMessage:"您还没有登录或者报名，无法预约!",
  toggelSubjectMessage:"未设置预约时间段，无法预约．",
  registerArea1:"国内",
  registerArea2:"海外",

  state0: "全部",
  state1: "未开展",
  state2: "进行中",
  state3: "已结束",
  or: "或",


  exState: "招商中",
  exState1: "展示中",
  exState2: "进行中",
  exState3: "已结束",


  exhibitionSelect: "请选择子账号",
  exhibitionName: "请输入展会名称/直播间名称",
  directExhName:"直播间名称/招聘会名称",
  participation: "参展报名",
  exhibitionVisit: "观展报名",
  exhibitionSignup:"我要报名",
  ticketsTips1:"尊敬的{0}用户，您已经购买了{1}，是否还要继续购买？",
  ticketsTips2:"{0}张门票",
  ticketsTips3:"{0}张门票",
  exhibitionPay:"我要支付",
  PaySuccess:"支付成功",
  sellAd:"我要做广告",
  joinVenue: "进入会场",
  exhibitionTime: "招聘会时间",
  exhibitionIntroduce: "展会简介",
  cluesTime1: "距离开幕还有",
  cluesTime2: "天",
  cluesTime3: "时 ",
  leave: "离开",
  day: "天",
  hour: "时",
  talkBtn: "我要洽谈",
  underNegotiation: "正在洽谈",
  talkBtnnotes: "点击进入直播间开始洽谈",
  newTalkBtn: "欢迎洽谈",
  //  talkBtn: "视频测试",
  loginPrompt: "请输入手机号",
  // loginTips: "请输入用户名/手机号/社会信用统一代码",
  password: "密码",
  password1: "请输入密码",
  accountLogin: "账号登录",
  ticketsLogin: "票号登录",
  banks: "票号",
  username: "姓名",
  username2: "姓名",
  registrant:"注册人",
  gender:"性别",
  zhiwei:"职位",
  school:"毕业院校",
  schoolTips:"请输入毕业院校",
  edu:"学历",
  highestEducation:"最高学历",
  educationTips:"请选择你的学历",
  educationTips1:"请选择你的最高学历",
  workExperience:"工作经验",
  experienceTips:"请选择工作经验",
  experienceList1:"应届毕业生",
  experienceList2:"一年以下",
  experienceList3:"1-2年",
  experienceList4:"2-3年",
  experienceList5:"3-4年",
  experienceList6:"4-5年",
  experienceList7:"5年以上",

  woman:"女",
  man:"男",
  phone: "手机号",
  phone1: "手机号",
  ticketNumber: "请输入票号",
  inputName: "请输入用户姓名",
  // oneToOne: "云洽展商",
  oneToOne: "招聘企业",
  to: "至",
  forum: "论坛",
  inputPhone: "请输入手机号",
  regInputPhone: "请输入手机号",
  inputAreaCode: "请选择区号",
  inputCode: "请输入验证码",
  setPwd: "设置密码",
  reqPwd: "确定密码",
  verificationCode: "验证码",
  overtime: "登录超时，请重新登录",
  sendVerificationCode: "获取验证码",
  toResend: "重新发送",
  userInfoRules: "信息不能为空",
  passwordRules: "密码不能为空",
  ticketRules: "票号不能为空",
  usernameRules: "姓名不能为空",
  phoneRules: "手机号不能为空",
  companyRules:"公司简介不能为空",
  licenseRules:"营业执照不能为空",
  logoRules:"logo不能为空",
  phoneLoginRules: "手机号不能为空",
  codeRules: "验证码不能为空",
  ageRules: "年龄不能为空",
  workExRules:"工作经验不能为空",
  studentRules:"学生证明不能为空",
  jlRules:"简历不能为空",
  numTip:"年龄必须为数字",
  phoneCorrectlyRules: "请输入正确的手机号",
  passwordCorrectlyRules: "密码应为6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种",
  emailRules: "邮箱不能为空",
  emailCorrectlyRules: "请输入正确的邮箱",
  propertyRules:"企业性质不能为空",
  protocol: "我已阅读并同意",
  deal: "《用户服务协议》",
  deal1:"《隐私政策》",
  goRedact:"去编辑",
  nickName: "姓名",
  trueName:"真实姓名",
  guestscompany: "公司",
  guestscompanyName: "公司名称",
  guestscompanyXZ:"公司性质",
  guestsBusiness: "主营业务",
  guestsLocation: "地区",
  guestsLocation1: "招聘工作地",
  guestsLocation2: "意向工作地",

  salaryRange:'薪资范围',
  companyName: "公司名称",
  headPortrait:"头像",
  companyName1: "请输入公司名称",
  companyProperty:"企业性质",
  companyProperty1:"国有企业",
  companyProperty2:"民营企业",
  companyProperty3:"合资企业",
  companyProperty4:"外资企业",
  companyProperty5:"个人独资企业",
  companyProperty6:"其他",
  // companyProperty7:"合伙企业",
  // companyProperty8:"有限责任公司",
  // companyProperty9:"股份有限公司",
  subiectTime: "可接受预约时间",
  subiectTimeTips: "请选择可接受预约时间",
  indexSou: "公司名称 / 地区 / 业务分类 / 关键词",
  indexSou1:"公司名称",
  interState:"面试状态",
  indexSou2:"请输入招聘会名称",
  companyEnName: "公司名称",
  // home: "公司所在城市",
  home: "所在城市",
  creditCode:"统一社会信用代码",
  businessLicense:"营业执照",
  home1: "请输入城市名称",
  age:"年龄",
  age1:"请输入您的年龄",
  userPost: "职务",
  userPost1:"请输入联系人职务",
  businessInfo: "主营业务",
  email: "邮箱",
  email1: "请输入邮箱地址",
  email2: "请输入企业邮箱地址",
  email3: "企业邮箱",
  contact: "联系方式",
  contact2: "联系方式",
  contact3: "联系方式",
  contactEmail:"联系邮箱",
  contactRules: "联系方式不能为空",
  userRules: "姓名不能为空",
  userCorrectlyRules: "姓名应为6-20字符和数",
  companyNameRules: "公司名称不能为空，且最多100个字符",
  companyNameEnRules: "公司名称不能为空",
  homeRules: "所在地不能为空",
  homeRules1:"所在城市不能为空",
  creditCodeTips:"统一社会信用代码不能为空",
  // trueNameRules: "姓名不能为空，且最多5个字符",
  trueNameRules: "姓名不能为空",
  jobRules: "职务不能为空，且最多60个字符",
  logout: "退出登录",
  marked: "是否退出当前用户?",
  hint: "提示",
  tips: "提示",
  endNegotiateTip: "您将结束此次面试，结束此次面试后，您可以邀请下一位面试者进入直播间，是否确认结束？",
  liveClass: "直播间分类",
  liveClass1: "招聘岗位",
  liveClass2: "求职意向",
  liveClass3: "岗位",
  firmQualityTips:"企业性质",
  exit: "退出",
  exit1: "关闭直播间",
  cancel: "取消",
  exitSuccess: "退出成功",
  hitDown: "点击'下载'按钮，下载最高版本chrome浏览器",
  leaveDown: "请前往chrome浏览器进入直播间",
  hold: "直播间功能不支持本浏览器运行,",
  COPC: "客服服务中心",
  aboutUs: "关于我们",
  blueBusiness: "蓝网商机",
  forwarderConference: "货代联合大会",
  GlobalShippingSummit: "全球海运峰会",
  InternationalFreightFair: "国际货运交易会",
  setToHomePage: "设为首页",
  shippingNetwork: "国际海运网",
  platform: "接待参展、观展、广告、调试等咨询",
  platform1: "接待招聘企业、应聘者、广告、调试等咨询",
  aboutExh: "关于WIFFA云聘",
  aboutWiff:"关于WIFFA云聘",
  exhTel: "关于WIFFA客服",
  organizer:"协办单位",
  supUnit:"支持单位",
  organizer1:"WIFFA云聘协办单位",
  supUnit1:"WIFFA云聘支持单位",
  allRightsReserved: "版权所有",
  humanResources:"人力资源服务许可证",
  customerPhone: "客服电话",
  AboutDirecruit:"关于云聘",
  license: "许可证号",
  offlineEvent: "线下展会",
  internetRecord: "辽ICP备",
  internetRecord1: "网站备案号",
  exhibitionRecord: "观展记录",
  applet: "小程序",
  pleaseEnterPwd: "请输入密码",
  pleaseAgainEnterPwd: "请在此输入密码",
  save: "保存",
  examineResume:"查看在线简历",
  saveInfonotes: "点击保存已修改内容",
  savePwdnotes: "点击保存提交密码修改",
  edit: "修改",
  editSuccess: "修改成功",
  enter: "进入",
  enter1:"进入会场",
  enternotes: "进入对应展会",
  editExh: "我要布展",
  editExhnotes: "可完善该直播间信息，以便用户更好的搜索到该直播间",
  enterExh: "进入直播",
  addRoom: "增加直播间",
  enterExhnotes: "点击开启直播并进入直播间",
  enterExhltnotes: "点击开启直播并进入论坛",
  ticText: "1、邀请人员进入可以参与直播",
  ticTextTwo: "  2、正在直播中的展会，被分配的票将无法进行回收",
  buy: "提交",
  buyTicket: "购票",
  balance: "云钱账户余额",
  recharge: "充值",
  goYQ:"前往云钱",
  sms: "短信",
  //求职意向
  jobThik:"求职意向:",
  postName:'岗位名称',
  intention:'意向岗位',
  inputPostName:'请输入岗位名称',
  inputPostName1:'请选择意向岗位',
  city:'城市',
  city2:'意向工作地:',
  inputCity:'请输入应聘所在地',
  salaryScope:'薪酬范围',
  chanceSalary:'请选择薪酬范围',
  jobState:'意向描述:',
  inputJobState:'请输入相关说明',
  //招聘岗位
  postTips:'请选择招聘岗位',
  locationTips:'请选择招聘工作地',
  postSay:'岗位描述',
  postSayTips:'请输入岗位描述',
  //个人中心模块
  personal: '个人信息',
  enterpriseInformation:'企业信息',
  ParticipationRecord: '参展记录',
  recruitPosition:'招聘岗位',
  ms:"面试记录",
  myTicket: '我的门票',
  subaccountManagement: '子账号管理',
  studioManagement: '直播间管理',
  appointment:'预约设置',
  appointmentnotes:'可对该直播间的预约时段进行设置',
  changePassword: '修改密码',
  createBBS: '创建论坛',
  visitorTickets: '观展门票',
  ticketsExhibition: '席位管理',
  exhSeat: "展会席位",
  error: "暂无数据",
  oneTone: '一对一',
  bbs: '论坛',
  accountId: '账号ID',
  mobilePhone: '手机号',
  name: '姓名',
  recruiter:"招聘官",
  ticName: '招聘会名称',
  confernece:'会议名称',
  classification: '分类',
  personalTextPrompt:'请完善中英文个人信息',
  //我的门票/观展门票
  fairName: '招聘会名称',
  forumName: '业务主题',
  fairTime: '展会时间',
  interviewTime:"面试时间",
  interviewer:"面试官",
  price: '价格',
  buyTime: '购买时间',
  operation: '操作',
  //我的门票/参展门票
  ticketsTypes: '席位类型',
  role: '角色',
  attributable: '已分配用户',
  //直播间管理
  bbsName: '论坛名称',
  studioFairName: '公司名称/直播间名称',
  studioFairName2: '直播间名称/招聘会名称',
  LiveRoomShowTip: '如需要额外的直播间，请联系管理员开通，联系方式：86-411-82817405',
  //观展记录
  studioName: '直播间名称',
  keyword: '关键字',
  broadcastType: '直播间类型',
  // seeContact: "查看联系方式",
  seeContact: "点击查看",
  helpfulHints: "友情提示!",
  helpfulHints2: "友情提示!",
  notLogin: "你还未登录，请先登录，若无账号请先注册",
  notLogin2: "你还未登录，请先登录",
  notLogin3: "你还未登录，点击登录",
  nologinInstructions:"您当前尚未登录，请前往登录。",
  notTicket: "你还未购票，请先购票",
  paymentMethod: "请选择付款方式",
  buyWatchTickets: "购买观展票",
  buyExhibitionTickets: "我要支付",
  site: "展位",
  site1: "张",
  onlineBuy: "线上购买",
  offlineBuy: "线下购买",
  total: "合计",
  free: "免费",
  weChat: "微信",
  payTreasure: "支付宝",
  CNY: "元",
  rates: "门票价格",
  buyTicketNumbers: "购买张数",
  buyTicketNumber: "展位数",
  PCS: "个",
  peopleSeat: "人席位展",
  oneSeat: "1人席位展",
  twoSeat: "2人席位展",
  threeSeat: "3人席位展",
  haveRead: "我已阅读",
  ticketAgreement: "购票协议",
  scanQR: "扫码了解更多内容",
  local: "地点",
  internationalization: "第九届中国国际货代年会暨国际货运对接展会",
  wxPay: "微信扫码支付",
  offlinePay:"线下支付",
  startTime: "2020年11月2-3日",
  sponsor: "主办单位",
  localPlace: "大连国际会议中心，大连富力希尔顿酒店",
  payMoney: "微信支付",
  scan: "请使用微信扫一扫",
  scanPay: "扫描二维码支付",
  backPay: "选择其他支付方式",
  guest: "嘉",
  client: "宾",
  chineseName: "(中文)",
  englishName: "(英文)",
  bbsVisitor: "嘉宾",
  compere: "主持人",
  compereCh: "主持人(中文)",
  compereEn: "主持人(英文)",
  sum: "共",
  time: "时间",
  watchReplay: "观看回放",
  intervieweeList:"面试人员列表",
  watch: "查看",
  watchjl:"查看简历",
  fillNote:"填写备注",
  newWatch: "查看",
  playback: "回放",
  playbacknotes: "点击收看直播回放",
  playbackList: "回放列表",
  inviteList:"招聘列表",
  talkCompany: "观众名单",
  talkCompanynotes: "点击查看观众名单",
  forumCompany: "洽谈公司列表",
  forumCompanynotes: "查看已洽谈公司列表",
  loginSuccess: "登陆成功",
  registerSuccess: "注册成功",
  bankCard: "开户行",
  accountName: "户名",
  company: "大连万发联合航贸科技有限公司",
  copyTic: "复制票号",
  cardNumber: "中信银行大连中山支行",
  accountCompany: "公司账户",
  companyAccount: "7211410182600144711",
  buyOffInfo: "线下购买请联系 04198258323 咨询详情",


  childAccount: '选择子账号',
  confirm: '确认',
  gobm:"去报名",
  findInput: "手机号",
  telNumber: "手机",
  doYouConfirm: '确认回收',
  tickets: '的票吗？',
  subAccount: '的账号吗？',
  editeStudio: '我要布展',
  editeStudio1: '直播间布展',
  suggestSize: '建议尺寸',
  suggestSize1:'请上传20M以内',
  suggestSize2:'JPG图片或PDF文件',
  suggestSize3:'logo图片',
  suggestSize4:'JPG图片',
  studentProveTips1:'请上传学生证或',
  studentProveTips2:'毕业证书',
  card: "货代小名片",
  makeCard: "13000位货代同行",
  extend: "等待交互",
  exhService: "云聘服务中心",
  serveTel: "服务热线",
  contactPeople: "联系人",
  companyMess: "公司管理",
  exhAttract: "展会招商",
  exhAttract1: "客服人员",
  advertisingAttract: "广告与企业推荐",
  cooperation:"院校与其他机构合作",
  overseasInvestment: "海外招商",
  cloud: "在线订舱交易",
  FAE: "技术支持工程师",
  vip: "WIFFA会员合作",
  directories: "全国110个城市",
  know: "1200+家信用会员",
  know1: "全国98个城市千家信用会员",
  // business: "展会服务中心",
  business1: "货代在线展会",
  business2: "云聘服务中心",
  click: '点击',
  uploadLogo: '上传logo',
  zhang: "张",
  startDate: '开始日期',
  endDate: '结束日期',
  date: "日期",
  segmentation: '以；分割',
  originalPassword: '原密码',
  newPassword: '新密码',
  confirmPassword: '确认密码',
  enterOriginalPassword: '请输入原密码',
  enterYourPassword: '请输入密码',
  passwordAgain: '请再次输入密码',
  samePassword: '与原密码一样!',
  twoPassinconsistent: '两次输入密码不一致!',
  notData: "暂无数据",
  seats: '席位数',
  forgotPwd: "忘记密码?",
  create: '创建',
  createSuccessful: '创建成功',
  getInMyTicket: '你可以在参展席位中查看',
  getInMyTicket1: '你可以在嘉宾席位中查看',
  see: "查看",
  giving: "分配",
  givingTitle: "分配",
  givingnotes:"点击可对该席位进行分配",
  recycling: "回收",
  recyclingnotes: "点击可回收该席位",
  addChildAccount: "添加子账号",
  addChildAccountnotes: "点击可为您的账号添加子账号",
  bbsTheme: "业务主题",
  bbsThemeCh: "业务主题(中文)",
  bbsThemeEn: "业务主题(英文)",
  bbsThemeChTips: "请输入业务主题(中文)",
  bbsThemeEnTips: "请输入业务主题(英文)",
  userPostChTips: "请输入职务(中文)",
  userPostEnTips: "请输入职务(英文)",
  truenameChTips: "请输入姓名(中文)",
  truenameEnTips: "请输入姓名(英文)",
  keyWordsChTips: "请输入业务关键字(中文)",
  keyWordsEnTips: "请输入业务关键字(英文)",
  companyLogoTips: "请选择公司logo",

  contactTips: "请输入联系方式",
  chooseSex:"请选择性别",
  classTips: "请选择分类",
  bbsForumAccount: "直播间总数",
  bbsForumLive: "开始中直播间",
  bbsForumNowNum: "当前参加论坛总人数",
  bbsTime: "论坛时间",
  bbsTimeCh: "论坛时间(中文)",
  bbsTimeEn: "论坛时间(英文)",
  introduction: "简介",
  introductionCh: "简介(中文)",
  introductionEn: "简介(英文)",
  companyLogo: "公司logo",
  applentLogo: "小程序分享图片",
  enterUserId: "请输入被添加人帐号ID/手机号/邮箱",
  addSubaccount: "添加子账号",
  addSubaccount1: "编辑子账号",
  subaccountText: "请输入被添加人的帐号ID/手机号/邮箱,若被添加人未注册,请先让其注册。",
  add: "添加",
  areYouSuretoDelete: "确定删除",
  delSuccess: "删除成功",
  icon: "phone",
  lineWait: "排队",
  lineUp: "我要排队",
  lineUpOn: "我已排队",
  wait: "当前直播间有人洽谈,请排队等候",
  usageTitle: "本系统支持pc浏览器和微信小程序进入",
  chrome: "PC浏览器推荐使用最新版chrome浏览器",
  down: "点击下载chrome浏览器",
  appletCode: "小程序二维码",
  appletContent:"扫描小程序二维码，手机端浏览，方便快捷",
  weChatCode: "微信扫描二维码",
  room: "直播间支持",
  exhibitor: "展商使用最新版的chrome浏览器",
  visitor: "观展使用最新版chrome浏览器和微信小程序",
  addSub: "你还没有子账号，请先添加子账号",
  accountError: "您的账号是别人的子账号不可以邀请子账号",
  hintContact: "联系方式",
  goAdd: "去添加",
  giveSuccess: "赠送成功",
  fileMaxSize: "文件大小不能超过20M",
  addSuccess: "添加成功",
  chanceSuccess: "修改成功",
  youLine: "你排队的",
  canEnter: "直播间现在可以进入",
  into: "立即进入",
  browserTip: "您当前的浏览器可能无法正常使用直播间的功能，推荐您使用最新版本的chrome浏览器进入。",
  gotIt: "知道了",
  browserLink: "下载chrome浏览器",
  userHasLeft: "用户已经离开",
  notMic: "没有麦克无法进行语音通话",
  notCamera: "没有摄像头无法进行视频通话",
  joinBlacklistTip: "确认要加入黑名单吗?",
  someoneSpeaking: "已经有人在发言",
  networkDisconnect: "网络断开连接",
  download: "下载",
  roomNumberText: "已有{0}人参与",

  peopleNumText: "已有{0}人排队",
  closeCameraAndMic: "不可以同时关闭摄像头和麦克",

  offlineAppointment: '线下预约',
  Booked: '已预约',

  seeOfflineAppointments: "查看线下预约",
  appointments: "查看预约",
  appointmentsotes: "查看已预约该直播间的嘉宾",
  appointmentltsotes: "查看已预约该论坛的嘉宾",
  unfollow: "取消预约",
  unfollownotes: "点击取消该直播间预约",
  makeSearch: "展会名称/论坛名称",

  sendEndTip: "提醒结束洽谈",
  talkInvite: '邀请预约人',
  talkPause: '暂停洽谈',
  talkRestart: '恢复洽谈',
  invite: '邀请',
  seatManagementTip: "管理直播间席位",
  seatManagement: "席位管理",
  // makeSearch: "直播间分类",


  queue: "查看排队",
  queuenotes: "查看该直播间正在排队的观众",

  ahead: "预约",
  newAhead: "预约",
  present: "当前已经有",
  people: "人",
  alreadyHave: "已有",
  attend: "人参与",
  homePage: "首页",
  bookRecord: '预约记录',
  goto: '前往',
  page: '页',


  Domestic1:'张琦',
  Domestic2:'于瑶',
  Domestic3:'Lucy Bee',
  Promotion1:'张琳',
  Promotion2:'刘宇政',
  Promotion3:'丁芳',
  Support1:'程培举',
  cooperation1:"李卓超",
  cooperation2:"赵若妘",
  cooperation3:"蒋英",

  localTime:'当地时间',

  //视频列表
  congratulationsTxt:'祝贺语',
  clickPlayInstructions:'手机用户，请双击播放按钮观看',

  //顶部导航添加表演标签
   perform:'才艺展示',

   visitors:'观展嘉宾',
   participants:'参展嘉宾',
   negotiation: '洽谈',

   MarketingPromotion: '直播推介',
   GuestsList: '嘉宾名单',
   Description: '关于WIFFA说明',


   NotStarted: '未开始',
   NotStarted1: '未开播',
   InLine: '洽谈中',
   newInLine: '我也排队',
   Finished: '已结束',


   Calling: '叫号',
   GuestList: '应聘者名录',
   GuestList1: '查看应聘者简历',
   GuestList2: '查看招聘企业信息',
   GuestListnotes: '点击可查看该展会下所有嘉宾名单与联系方式',
   Exhibitors: '查看展商',
   Sharelinks: '分享链接',
   ShareTicket: '分享门票',
   share: '分享',
   shared: '已分享',
   takeBack: '收回',
   takeBackTip: '确认要收回该票吗',

   CreateTime: '创建时间',

   RegisterNow: '立即注册',

   OnlineExhibitorRegister: "线上参展报名",
   OnlineVisitorRegister: "线上观展报名",
   OfflineExhibitorList: "线下参展展商",
   OfflineExhibitiorRegistor: "线下参展报名",

   submit: '提交',
   newStudioName: '业务主题',
   newKeyWord: '业务关键字',


   endnegotiationMessage: '是否结束与当前客户洽谈？',
   Soundcontrol:'声音控制',
   Cameracontrol: '摄像头控制',

   Introductionch: '公司简介(中文)',
   Introductionen: '公司简介(英文)',
   Introduction: '公司简介',
   IntroductionPerson:'个人简介',
   IntroductionTips:'可以填写个人简介以便面试官可以更好的了解你',
   IntroductionCom:"公司介绍",
   hiddenMessage:'隐藏个人信息设置',
   // Logo: '公司LOGO',
   Logo: '上传logo',
   upResume:"上传简历",
   upStudentProve:"学生证明",
   upStudentProve1:"上传证明",
   Pencilnotes: '改变画笔粗细',
   Soundcontrolnotes: '打开/关闭声音',
   Cameracontrolnotes: '打开/关闭摄像头',
   Brushnotes: '清除涂鸦',
   Beginchattingnotes: '直播间开播',
   Sharethefilenotes: '上传白板演示间演示文件',
   UploadDownloadnotes: '上传共享文件',
   liveEndnotes: '与当前用户结束洽谈',
   liveExitnotes: '退出当前直播间',
   liveSendnotes: '发送当前消息',
   liveRefreshnotes: '刷新当前列表',
   liveRefresh: '刷新',
   uploadTips:"+请上传图片,word,excel,ppt,mp4,mp3等文件,大小不超过50M",
   addword:"+添加演示文件",
   livePeoPleBookednotes: '你可以通过回“call”把预约表中的对接人优先到你的队列首位',
   livePeoPleBookedRefreshnotes: '你可以通过刷新键刷新你的对接列表',
   livePeoPleLinenotes: '你可以通过Call 来优先对接该访客',
  //  livePeoPleLineRefreshnotes: '你可以通过刷新键刷新你的对接列表',

   outTextMessage: '您确认是否要退出此次面试。',

   Schedule: '直播间预约设置',
   FullDay: '全天',
   StartingTime: '起始时间',
   EndTime: '结束时间',

  //直播间设备检测
  deviceTest: '设备检测',
  micControl: '声音控制',
  cameraControl: '摄像头控制',
  beginTalkTip: '请点击<img class="begin-talk-tip-icon" src="./imgs/kaishi.png"></img>按钮，开始面试',

  endTalkTipDetail: '您的面试已结束，感谢您的参与。',
  roomPausedTip: '直播已暂停，请等待主播重新开启...',
  canNotPauseTip: '直播间洽谈还未开始，不能暂停',
  invitationUserTip: '你确认要邀请新用户吗',
  invitationXUserTip: '你确认要邀请{x}进行视频面试吗？',
  invitationSuccess: '邀请成功，已通知用户进入直播间',

  subscribeListCount: '历史记录(${num})',
  queueListCount: '排队(${num})',

  noOneSrubscribed: '还没有历史记录哦~',
  noOneInQueue: '还没有人排队哦~',


  //公告列表
  noticeList: '公告列表',
  noticeContent: '内容',
  noticeDate: '日期',
  noticeType: '类型',
  noticeExhName: '展会',
  noticeRole:'角色',
  // roomOutTitle: '您是直播间内唯一主播，结束洽谈后将关闭直播间，并将所有观展方踢出直播间/队列，确认结束洽谈？',
  roomOutTitle: '您是直播间内唯一面试官，退出后将关闭直播间，是否确认退出？',

  // 设备检测
  deviceLink: '设备连接',
  deviceAuthTip: '设备检测前请务必给当前页面开放摄像头，麦克风权限哦~',
  beginTest: '开始检测',
  linkAgain: '重新连接',
  cameraSelect: '摄像头选择',
  seeSelfClearly: '是否可以清楚的看到自己？',
  yes: '可以',
  no: '不可以',
  speakerSelect: '扬声器选择',
  turnHigh: '请调高设备音量, 点击播放下面的音频试试～',
  hearClearly: '是否可以听到声音？',
  micSelect: '麦克风选择',
  sayHello: '对着麦克风说\'哈喽\'试试～',
  canSeeSoundIconMove: '是否可以看到音量图标跳动？',
  os: '操作系统',
  browserVersion: '浏览器版本',
  shareScreen: '屏幕共享能力',
  netDelay: '网络延迟',
  uplinkQuality: '上行网络质量',
  downlinkQuality: '下行网络质量',
  testRemainTime: '检测剩余时间',
  seeTestReport: '查看检测报告',
  testReport: '检测报告',
  testAgain: '重新检测',
  // registerAreaCh: '国内',
  registerAreaCh: '个人',
  // registerAreaEn: '海外',
  registerAreaEn: '企业',
  codeError: "验证码不正确",
  testFinish: '完成检测',
  notice:'公告：',
  notice1:'公告',
  specifyNotice:'通知',
  signUpTip:'报名后可查看联系方式',
  apply:'报名',
  completeInfo:"请填写完整信息！",
  checkPassMistake:"两次输入的密码不一致！",
  passMistake:"密码太简单，请重新输入！",
  perfectInfo:"请完善个人信息",
  appointmentTime:"预约时间",
  deviceTest: '设备检测',
  noApplyExhibition:"展会暂未开始售票，请稍后再来选购。",
  exhibitionNotStarted:"展会未开始",
  broadcastTipOne:"视频文件只可以在PC端进行播放",
  broadcastTipTwo:"文件管理的视频文件上限50M",
  liveTip:"当前视频面试并未结束,点击确认结束当前面试并邀请新的应聘者",
  companyLogin:"招聘企业登录",
  personalLogin:"应聘个人登录"
}
